export default "__VITE_ASSET__DuKHVa46__"